export const SAVE_BUTTON_BAR_LABELS = { cancel: "cancel", publish: "insert" };
